// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet communicatie-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { BerichtenPakkettenMetProlongatieInfoOphalenParams } from '../model/berichtenPakkettenMetProlongatieInfoOphalenParams';

import type { BerichtenProlongatiewijzigingenOphalenParams } from '../model/berichtenProlongatiewijzigingenOphalenParams';

import type { BerichtenProlongatiewijzigingenVoorPakketVersieOphalenParams } from '../model/berichtenProlongatiewijzigingenVoorPakketVersieOphalenParams';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails';

import type { Result1OfCommunicatieFeaturesBerichtenGetPakkettenMetProlongatieInfoDto } from '../model/result1OfCommunicatieFeaturesBerichtenGetPakkettenMetProlongatieInfoDto';

import type { Result1OfCommunicatieFeaturesBerichtenMaakDeelbareLinkDto } from '../model/result1OfCommunicatieFeaturesBerichtenMaakDeelbareLinkDto';

import type { Result1OfCommunicatieFeaturesBerichtenWijzigingenDto } from '../model/result1OfCommunicatieFeaturesBerichtenWijzigingenDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.ProlongatiewijzigingenInzien</li></ul>
 * @summary Haalt prolongatiewijzigingen op.
 */
export const berichtenProlongatiewijzigingenOphalen = (
  params?: MaybeRef<BerichtenProlongatiewijzigingenOphalenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<Result1OfCommunicatieFeaturesBerichtenWijzigingenDto>(
    {
      url: `/api/v1/communicatie/prolongatiewijzigingen`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getBerichtenProlongatiewijzigingenOphalenQueryKey = (
  params?: MaybeRef<BerichtenProlongatiewijzigingenOphalenParams>,
) => {
  return [
    'api',
    'v1',
    'communicatie',
    'prolongatiewijzigingen',
    ...(params ? [params] : []),
  ] as const;
};

export const getBerichtenProlongatiewijzigingenOphalenQueryOptions = <
  TData = Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRef<BerichtenProlongatiewijzigingenOphalenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getBerichtenProlongatiewijzigingenOphalenQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>
  > = ({ signal }) => berichtenProlongatiewijzigingenOphalen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>,
    TError,
    TData
  >;
};

export type BerichtenProlongatiewijzigingenOphalenQueryResult = NonNullable<
  Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>
>;
export type BerichtenProlongatiewijzigingenOphalenQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haalt prolongatiewijzigingen op.
 */

export function useBerichtenProlongatiewijzigingenOphalen<
  TData = Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRef<BerichtenProlongatiewijzigingenOphalenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof berichtenProlongatiewijzigingenOphalen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBerichtenProlongatiewijzigingenOphalenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary Maakt een link zodat een relatie de prolongatiewijzigingen kan inzien.
 */
export const berichtenMaakDeelbareLink = (
  polisnummer: MaybeRef<string | undefined | null>,
  relatienummer: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = unref(polisnummer);
  relatienummer = unref(relatienummer);

  return customInstance<Result1OfCommunicatieFeaturesBerichtenMaakDeelbareLinkDto>(
    {
      url: `/api/v1/communicatie/maak-deelbare-link/${polisnummer}/${relatienummer}`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getBerichtenMaakDeelbareLinkMutationOptions = <
  TError = ErrorType<
    MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof berichtenMaakDeelbareLink>>,
    TError,
    { polisnummer: string | undefined | null; relatienummer: number | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof berichtenMaakDeelbareLink>>,
  TError,
  { polisnummer: string | undefined | null; relatienummer: number | undefined | null },
  TContext
> => {
  const mutationKey = ['berichtenMaakDeelbareLink'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof berichtenMaakDeelbareLink>>,
    { polisnummer: string | undefined | null; relatienummer: number | undefined | null }
  > = (props) => {
    const { polisnummer, relatienummer } = props ?? {};

    return berichtenMaakDeelbareLink(polisnummer, relatienummer, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BerichtenMaakDeelbareLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof berichtenMaakDeelbareLink>>
>;

export type BerichtenMaakDeelbareLinkMutationError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Maakt een link zodat een relatie de prolongatiewijzigingen kan inzien.
 */
export const useBerichtenMaakDeelbareLink = <
  TError = ErrorType<
    MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof berichtenMaakDeelbareLink>>,
      TError,
      { polisnummer: string | undefined | null; relatienummer: number | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof berichtenMaakDeelbareLink>>,
  TError,
  { polisnummer: string | undefined | null; relatienummer: number | undefined | null },
  TContext
> => {
  return useMutation(getBerichtenMaakDeelbareLinkMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.ProlongatiewijzigingenInzien</li></ul>
 * @summary Haalt pakketten met prolongatie-informatie op voor een relatie.
 */
export const berichtenPakkettenMetProlongatieInfoOphalen = (
  params?: MaybeRef<BerichtenPakkettenMetProlongatieInfoOphalenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<Result1OfCommunicatieFeaturesBerichtenGetPakkettenMetProlongatieInfoDto>(
    {
      url: `/api/v1/communicatie/pakketten-met-prolongatieinfo`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getBerichtenPakkettenMetProlongatieInfoOphalenQueryKey = (
  params?: MaybeRef<BerichtenPakkettenMetProlongatieInfoOphalenParams>,
) => {
  return [
    'api',
    'v1',
    'communicatie',
    'pakketten-met-prolongatieinfo',
    ...(params ? [params] : []),
  ] as const;
};

export const getBerichtenPakkettenMetProlongatieInfoOphalenQueryOptions = <
  TData = Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRef<BerichtenPakkettenMetProlongatieInfoOphalenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getBerichtenPakkettenMetProlongatieInfoOphalenQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>
  > = ({ signal }) => berichtenPakkettenMetProlongatieInfoOphalen(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>,
    TError,
    TData
  >;
};

export type BerichtenPakkettenMetProlongatieInfoOphalenQueryResult = NonNullable<
  Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>
>;
export type BerichtenPakkettenMetProlongatieInfoOphalenQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haalt pakketten met prolongatie-informatie op voor een relatie.
 */

export function useBerichtenPakkettenMetProlongatieInfoOphalen<
  TData = Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  params?: MaybeRef<BerichtenPakkettenMetProlongatieInfoOphalenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof berichtenPakkettenMetProlongatieInfoOphalen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBerichtenPakkettenMetProlongatieInfoOphalenQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.ProlongatiewijzigingenInzien</li></ul>
 * @summary Haalt prolongatiewijzigingen op voor een specifieke pakketversie.
 */
export const berichtenProlongatiewijzigingenVoorPakketVersieOphalen = (
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<BerichtenProlongatiewijzigingenVoorPakketVersieOphalenParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  polisnummer = unref(polisnummer);
  params = unref(params);

  return customInstance<Result1OfCommunicatieFeaturesBerichtenWijzigingenDto>(
    {
      url: `/api/v1/communicatie/prolongatiewijzigingen/pakketten/${polisnummer}/versies`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getBerichtenProlongatiewijzigingenVoorPakketVersieOphalenQueryKey = (
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<BerichtenProlongatiewijzigingenVoorPakketVersieOphalenParams>,
) => {
  return [
    'api',
    'v1',
    'communicatie',
    'prolongatiewijzigingen',
    'pakketten',
    polisnummer,
    'versies',
    ...(params ? [params] : []),
  ] as const;
};

export const getBerichtenProlongatiewijzigingenVoorPakketVersieOphalenQueryOptions = <
  TData = Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<BerichtenProlongatiewijzigingenVoorPakketVersieOphalenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getBerichtenProlongatiewijzigingenVoorPakketVersieOphalenQueryKey(
    polisnummer,
    params,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>
  > = ({ signal }) =>
    berichtenProlongatiewijzigingenVoorPakketVersieOphalen(
      polisnummer,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(() => unref(polisnummer) !== null && unref(polisnummer) !== undefined),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>,
    TError,
    TData
  >;
};

export type BerichtenProlongatiewijzigingenVoorPakketVersieOphalenQueryResult = NonNullable<
  Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>
>;
export type BerichtenProlongatiewijzigingenVoorPakketVersieOphalenQueryError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

/**
 * @summary Haalt prolongatiewijzigingen op voor een specifieke pakketversie.
 */

export function useBerichtenProlongatiewijzigingenVoorPakketVersieOphalen<
  TData = Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>,
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
>(
  polisnummer: MaybeRef<string | undefined | null>,
  params?: MaybeRef<BerichtenProlongatiewijzigingenVoorPakketVersieOphalenParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof berichtenProlongatiewijzigingenVoorPakketVersieOphalen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBerichtenProlongatiewijzigingenVoorPakketVersieOphalenQueryOptions(
    polisnummer,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Communicatie.ProlongatiewijzigingenLinkNaarRelatieVersturen</li></ul>
 * @summary Verstuurd een mail naar de relatie met een nieuwe link om de prolongatiewijzigingen in te zien.
 */
export const berichtenProlongatiewijzigingenLinkNaarRelatieMailen = (
  relatienummer: MaybeRef<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  relatienummer = unref(relatienummer);

  return customInstance<void>(
    {
      url: `/api/v1/communicatie/prolongatiewijzigingen/mail-link-naar-relatie/${relatienummer}`,
      method: 'POST',
      signal,
    },
    options,
  );
};

export const getBerichtenProlongatiewijzigingenLinkNaarRelatieMailenMutationOptions = <
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof berichtenProlongatiewijzigingenLinkNaarRelatieMailen>>,
    TError,
    { relatienummer: number | undefined | null },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof berichtenProlongatiewijzigingenLinkNaarRelatieMailen>>,
  TError,
  { relatienummer: number | undefined | null },
  TContext
> => {
  const mutationKey = ['berichtenProlongatiewijzigingenLinkNaarRelatieMailen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof berichtenProlongatiewijzigingenLinkNaarRelatieMailen>>,
    { relatienummer: number | undefined | null }
  > = (props) => {
    const { relatienummer } = props ?? {};

    return berichtenProlongatiewijzigingenLinkNaarRelatieMailen(relatienummer, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BerichtenProlongatiewijzigingenLinkNaarRelatieMailenMutationResult = NonNullable<
  Awaited<ReturnType<typeof berichtenProlongatiewijzigingenLinkNaarRelatieMailen>>
>;

export type BerichtenProlongatiewijzigingenLinkNaarRelatieMailenMutationError = ErrorType<
  MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails | void
>;

/**
 * @summary Verstuurd een mail naar de relatie met een nieuwe link om de prolongatiewijzigingen in te zien.
 */
export const useBerichtenProlongatiewijzigingenLinkNaarRelatieMailen = <
  TError = ErrorType<
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
    | void
  >,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof berichtenProlongatiewijzigingenLinkNaarRelatieMailen>>,
      TError,
      { relatienummer: number | undefined | null },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof berichtenProlongatiewijzigingenLinkNaarRelatieMailen>>,
  TError,
  { relatienummer: number | undefined | null },
  TContext
> => {
  return useMutation(
    getBerichtenProlongatiewijzigingenLinkNaarRelatieMailenMutationOptions(options),
    queryClient,
  );
};
